// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"RootLayout_rootContainer__A5-IK"};